<!--合作伙伴-->
<template>
<div class="cplist">
  <li v-for="(item, index) in dataImg" :key="index">
    <div><img :src="item.src"></div>
  </li>
</div>

</template>

<script>
import api from '@/apis/sale/sale'
export default {
  data() {
    return {
      dataImg: [],
    };
  },
  methods: {
    //获取数据
    getList(){
      api.getPartner().then(res=>{
        if(res.code==10000){
          let _data = res.data.list
          let _arr = _data.map(item=>{
            return{
              id:item.id,
              src:item.pictures
            }
          })
          this.dataImg = _arr
        }
      })
    },
  },
  mounted() {
    this.getList()
  },
};
</script>

<style lang="less" scoped>
.cplist{
  overflow-y: auto;
   padding:.4rem; height: 100%;  display: flex; flex-direction: row; flex-wrap: wrap;
  li{ height: 50%; width: 25%; padding: .3rem; 
    div{ background: #fff; width: 100%; height: 100%; display: flex; align-items: center; justify-content: center;
      img{ width: 100%; display: block;}}
  }
}
</style>